module.exports = __webpack_public_path__ + "videos/3d-transform_cn.464219a.mp4";